import React from "react";
import Navigation from "../Navigation";
import "./Header.css";

const Header = () => {
  return (
    <div>
      <Navigation />
    </div>
  );
};

export default Header;
